import { Checkout, PricingContainer } from 'pages';
import { makeRoute } from './helpers/makeRoute';
import {} from './middlewares';
import { locations } from './locations';

export default [
  makeRoute({
    path: locations.subscription.pricing.pathname(''),
    component: PricingContainer,

    middlewares: [],
  }),
  makeRoute({
    path: locations.subscription.checkout.pathname,
    component: Checkout,

    middlewares: [],
  }),
];
